import { useHandler } from "@redotech/react-util/hook";
import {
  getMatchTypeLabel,
  ListToListMatchType,
} from "@redotech/redo-model/advanced-flow/common/condition";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const ListToListMatchTypeSelect = memo(
  function ListToListMatchTypeSelect({
    matchType,
    fieldLabelIsPlural,
    onMatchTypeChange,
  }: {
    matchType?: ListToListMatchType;
    fieldLabelIsPlural: boolean;
    onMatchTypeChange: (matchType: ListToListMatchType) => void;
  }) {
    const setMatchType = useHandler(
      ({
        item: matchTypeListItem,
      }: {
        item: RedoListItem<ListToListMatchType>;
      }) => {
        onMatchTypeChange(matchTypeListItem.value);
      },
    );

    const options: RedoListItem<ListToListMatchType>[] = useMemo(() => {
      return Object.values(ListToListMatchType).map((type) => ({
        value: type,
        type: "text",
        id: type,
        text: getMatchTypeLabel(type, fieldLabelIsPlural),
      }));
    }, [fieldLabelIsPlural]);

    return (
      <RedoSingleSelectDropdownInput<ListToListMatchType>
        fitToAnchor={false}
        flexGrow={false}
        options={options}
        optionSelected={setMatchType}
        placeholder="Select a criteria"
        selectedItem={options.find((o) => o.id === matchType)}
        size="xs"
      />
    );
  },
);
